import { render } from "./level.vue?vue&type=template&id=0fa6781b&scoped=true"
import script from "./level.vue?vue&type=script&lang=js"
export * from "./level.vue?vue&type=script&lang=js"

import "./level.vue?vue&type=style&index=0&id=0fa6781b&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fa6781b"]])

export default __exports__